import { apiClient } from './client';

export type ApiKeyRole = 'Viewer' | 'Editor' | 'Admin';

export interface ApiKey {
  id: string;
  name: string;
  prefix: string;
  role: ApiKeyRole;
  createdAt: string;
  expiresAt: string | null;
  lastUsedAt: string | null;
  revokedAt: string | null;
}

export interface CreateApiKeyResponse {
  id: string;
  name: string;
  prefix: string;
  role: ApiKeyRole;
  createdAt: string;
  expiresAt: string | null;
  key: string;
}

export interface CreateApiKeyRequest {
  name: string;
  role: ApiKeyRole;
  expiresAt?: string | null;
}

export const listApiKeys = () =>
  apiClient.get<ApiKey[]>('/api/api-keys').then(r => r.data);

export const createApiKey = (req: CreateApiKeyRequest) =>
  apiClient.post<CreateApiKeyResponse>('/api/api-keys', req).then(r => r.data);

export const revokeApiKey = (id: string) =>
  apiClient.delete(`/api/api-keys/${id}`).then(r => r.data);
